<template>
  <v-card flat tile>
    <v-card-text class="ma-0 pa-0">
        <v-row no-gutters>
          <v-col cols="12">
            <template>
              <router-view></router-view>
            </template>
          </v-col>
        </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'Groups',
    components: {
    },
    props: {
      budgetIterationId: {}
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters([]),
          
    },
    methods: {
      ...mapActions(['changeLoading']),   
    }
  }
</script>

<style lang="scss" scoped>

</style>
